import VueVideoPlayer from '@videojs-player/vue'

export * from '@videojs-player/vue'
export default VueVideoPlayer
